import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { login } from "../../../store/thunks/authThunks";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  TextField,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import { useAppDispatch } from "../../../hooks";
import { NavLink } from "react-router-dom";

const baseUrl = import.meta.env.VITE_API_URL;

const validationSchema = Yup.object({
  email: Yup.string().email("Correo inválido").required("Requerido"),
  password: Yup.string().required("Requerido"),
});

export const LoginTab = () => {
  const dispatch = useAppDispatch();

  const handleGoogleLogin = () => {
    window.open(`${baseUrl}/auth/collaborator/google-login`, "_self");
  };

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 440,
        borderRadius: 3,
        boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      }}
    >
      <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            component="h1"
            sx={{ fontSize: 26, fontWeight: 700, mb: 0.5 }}
          >
            Bienvenido
          </Typography>
          <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
            Ingresa con tu cuenta de colaborador
          </Typography>
        </Box>

        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            dispatch(login(values.email, values.password));
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                <Field
                  as={TextField}
                  label="Correo electrónico"
                  name="email"
                  type="email"
                  fullWidth
                  size="small"
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
                <Field
                  as={TextField}
                  label="Contraseña"
                  name="password"
                  type="password"
                  fullWidth
                  size="small"
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                />
                <Button
                  type="submit"
                  fullWidth
                  color="primary"
                  variant="contained"
                  disabled={isSubmitting}
                  sx={{ py: 1.25, fontWeight: 600 }}
                >
                  Iniciar sesión
                </Button>
                <Box sx={{ textAlign: "center" }}>
                  <MuiLink
                    component={NavLink}
                    to="/auth/forgot-password"
                    underline="hover"
                    sx={{ fontSize: 14 }}
                  >
                    ¿Olvidaste tu contraseña?
                  </MuiLink>
                </Box>
              </Box>

              <Divider sx={{ my: 3, color: "text.secondary", fontSize: 13 }}>
                o
              </Divider>

              <Button
                onClick={handleGoogleLogin}
                fullWidth
                variant="outlined"
                sx={{ py: 1.25, fontWeight: 600, color: "text.primary" }}
                startIcon={
                  <img
                    src="https://cdn-icons-png.flaticon.com/256/300/300221.png"
                    alt="Google"
                    style={{ width: 20, height: 20 }}
                  />
                }
              >
                Continuar con Google
              </Button>
            </Form>
          )}
        </Formik>
      </CardContent>
    </Card>
  );
};
